import React from 'react';

import { useAppContext } from '../../hooks';

import Layout from '../Layout';
import Heading from '../Heading';

import SetPasswordForm from './SetPasswordForm';

function SetPassword() {
  const { config } = useAppContext();
  return (
    <Layout>
      <Heading>
        {i18n.sprintf(i18n.gettext('Set password for %s'), config.username)}
      </Heading>
      <SetPasswordForm />
    </Layout>
  );
}

export default SetPassword;
